module.exports = __webpack_public_path__ + "static/media/icon-warning-sign.0c502c7e.svg";